/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFairnow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.933 3.004h8.063c.208 0 .416.01.622.031.31.031.422.216.37.514-.445 2.487-2.07 4.246-4.766 4.28-4.864.06-9.727.026-14.59.038-.42 0-.63-.123-.598-.589.035-.527.05-1.062.002-1.588C1.902 4.238 3.061 2.984 4.701 3c2.744.026 5.488.007 8.232.007zM10.075 9.32c2.196 0 4.393.01 6.588-.008.47-.004.58.152.525.602-.318 2.631-2.706 4.276-4.942 4.212-3.197-.091-6.398-.035-9.596-.011-.512.003-.647-.156-.628-.64.034-.889.006-1.78.016-2.668.01-.868.579-1.468 1.451-1.475 2.196-.017 4.392-.006 6.588-.006v-.004zm-2.27 6.266c1.38 0 2.76.011 4.139-.008.419-.005.567.096.509.547-.31 2.411-2.277 4.2-4.71 4.222-1.739.016-3.478-.005-5.216.01-.377.004-.54-.085-.526-.5.028-.888-.002-1.777.01-2.665.015-1.014.608-1.592 1.655-1.601 1.379-.012 2.759-.004 4.138-.004z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFairnow as Fairnow };
